module.exports = __webpack_public_path__ + "39261a88f5e8e88f200eb9ed3c3281a0.png";